import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

// MODULES
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MaterialCustomModule } from '../../material-custom.module';
import { SharedComponentsModule } from '../../shared-components.module';

// PIPES
import { PipeModule } from '../shared/pipes/pipe.module';
import { TagModule } from '../tag/tag.module';
import { UiModule } from '../ui/ui.module';

// COMPONENTS
import {
  FilterCategoryComponent,
  FilterChannelComponent,
  FilterClientPaymentTermComponent,
  FilterClientPurchaseOrderTypeComponent,
  FilterClientTypesComponent,
  FilterClientsComponent,
  FilterCompanyComponent,
  FilterFactoryComponent,
  FilterComponent,
  FilterMultiselectChipsComponent,
  FilterWarehouseComponent,
  FilterTagComponent,
  FilterOrderComponent,
  FilterLocationsComponent,
  FilterUserComponent,
  FilterUserGroupsComponent,
} from './components';

const components = [
  FilterCategoryComponent,
  FilterChannelComponent,
  FilterClientPaymentTermComponent,
  FilterClientPurchaseOrderTypeComponent,
  FilterClientTypesComponent,
  FilterClientsComponent,
  FilterCompanyComponent,
  FilterFactoryComponent,
  FilterComponent,
  FilterWarehouseComponent,
  FilterMultiselectChipsComponent,
  FilterTagComponent,
  FilterOrderComponent,
  FilterLocationsComponent,
  FilterUserComponent,
  FilterUserGroupsComponent,
];

const angularModules = [CommonModule, MaterialCustomModule];
const lumModules = [
  SharedComponentsModule,
  FormsModule,
  ReactiveFormsModule,
  PipeModule,
  UiModule,
  TagModule,
];
@NgModule({
  declarations: [...components],
  imports: [...angularModules, ...lumModules],
  exports: [...components],
  schemas: [NO_ERRORS_SCHEMA],
})
export class FilterModule {}
